import { memo } from "react"
import { useNavigate } from "@tanstack/react-router"
import { IconArrowLeftOutline18 as ArrowLeft } from "nucleo-ui-outline-18"

import { IconButton } from "@productlane/ui"

// A phone shows one pane at a time, so a detail view needs its own way back to
// the list. Same control the thread view uses in focus mode.
export const MobileBackButton = memo(
	({ to, label }: { to: string; label: string }) => {
		const navigate = useNavigate()
		return (
			<IconButton
				Icon={ArrowLeft}
				iconStrokeWidth={2}
				variant="ghost"
				aria-label={label}
				// Without this the button is a flex item that shrinks to a few
				// unclickable pixels next to a long title.
				className="size-8 shrink-0 sm:hidden"
				onClick={() => void navigate({ href: to })}
			/>
		)
	},
)
